
























































/** mustChangePassword из /me не показываем: на бэкенде поле зашито в false и фактом не является */
import { AxiosResponse } from 'axios';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import MmStates from '../../components/MmStates.vue';
import { fetchAdminMe } from '../../api/auth';
import { readMmError } from '../../api/mmHttp';
import { formatDiagnostics, MmError } from '../../core/errors';
import { formatDateTime, orDash } from '../../core/format';
import { MmAdminMe } from '../../types/domain';
import { MmErrorCode } from '../../types/enums';

const KEY = 'priceMonitoring.mobileMonitoring.auditors.';

const SECTION_HINT = 'admin/me';

/** На проводе роль приходит в нижнем регистре, поэтому сравниваем без учёта регистра */
const WIRE_ROLE_ORG_ADMIN = 'org_admin';

@Component({
	components: { MmStates },
})
export default class AdminProfileModal extends Vue {
	@Prop({ default: false }) readonly visible!: boolean;

	profile: MmAdminMe | null = null;

	isLoading: boolean = false;

	loadError: MmError | null = null;

	/** Ответ применяем, только если его поколение текущее: окно могли закрыть до ответа */
	private requestSeq: number = 0;

	@Watch('visible')
	onVisibleChanged(next: boolean): void {
		if (next) {
			this.reload();

			return;
		}

		/** При закрытии данные не сбрасываем: окно уезжает анимацией, и подмена была бы видна */
		this.requestSeq += 1;
	}

	reload(): void {
		this.requestSeq += 1;

		const seq = this.requestSeq;

		this.isLoading = true;
		this.loadError = null;
		this.profile = null;

		fetchAdminMe()
			.then((response: AxiosResponse) => {
				if (seq !== this.requestSeq) {
					return;
				}

				this.isLoading = false;
				this.profile = response.data as MmAdminMe;
			})
			.catch((error: any) => {
				if (seq !== this.requestSeq) {
					return;
				}

				this.isLoading = false;

				/** Ветвимся по машинному коду, а не по тексту сообщения: он локализован сервером и меняется */
				this.loadError = readMmError(error, SECTION_HINT);
			});
	}

	handleCancel(): void {
		this.$emit('cancel');
	}

	get viewState(): string {
		if (this.isLoading) {
			return 'loading';
		}

		if (this.loadError !== null) {
			if (this.loadError.code === MmErrorCode.FORBIDDEN) {
				return 'forbidden';
			}

			if (this.loadError.code === MmErrorCode.MISCONFIGURED) {
				return 'misconfigured';
			}

			return 'error';
		}

		return this.profile === null ? 'loading' : 'ready';
	}

	get stateTitle(): string {
		return this.viewState === 'error' ? (this.$t(KEY + 'profileError') as string) : '';
	}

	get stateServiceText(): string {
		return this.loadError === null || !this.loadError.message ? '' : String(this.loadError.message);
	}

	get errorDiagnostics(): string {
		return this.loadError === null ? '' : formatDiagnostics(this.loadError.diagnostics);
	}

	/** Сознательно не смотрим на признак повторяемости: частый 401 лечится повтором, запрос безопасен */
	get isRetryable(): boolean {
		return this.viewState === 'error';
	}

	get modalTitle(): string {
		return this.$t(KEY + 'profileTitle') as string;
	}

	get closeText(): string {
		return this.$t('shared.actions.close') as string;
	}

	get loginLabel(): string {
		return this.$t(KEY + 'profileLogin') as string;
	}

	get roleLabel(): string {
		return this.$t(KEY + 'profileRole') as string;
	}

	get organizationLabel(): string {
		return this.$t(KEY + 'profileOrganization') as string;
	}

	get instanceLabel(): string {
		return this.$t(KEY + 'profileInstance') as string;
	}

	get serverTimeLabel(): string {
		return this.$t(KEY + 'profileServerTime') as string;
	}

	get loginText(): string {
		return orDash(this.profile === null ? null : this.profile.spUsername);
	}

	get roleText(): string {
		const raw = this.profile === null || this.profile.role === null || this.profile.role === undefined
			? ''
			: String(this.profile.role).trim();

		/* Регистр приводим: бэкенд отдаёт роль по-разному в теле ответа и в токене */
		if (raw.toLowerCase() === WIRE_ROLE_ORG_ADMIN) {
			return this.$t(KEY + 'profileRoleOrgAdmin') as string;
		}

		return orDash(raw);
	}

	get organizationText(): string {
		return orDash(this.profile === null ? null : this.profile.organizationName);
	}

	get instanceText(): string {
		return orDash(this.profile === null ? null : this.profile.instanceKey);
	}

	get serverTimeText(): string {
		return formatDateTime(this.profile === null ? null : this.profile.serverTime);
	}
}
